module.exports = __webpack_public_path__ + "static/media/favoritesFull.2e2741e8.svg";